var $b33c94de89ff5291$exports = {};
$b33c94de89ff5291$exports = {
    "colorFormat": `Farbformat`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$b33c94de89ff5291$exports as default};
//# sourceMappingURL=de-DE.mjs.map
